<template>
	<v-form ref="unitary_form">
		<v-autocomplete
			dense
			:items="legacy_contracts"
			item-value="id"
			item-text="name"
			class="grv-input"
			name="Contrat"
			:loading="loading_contracts"
			:rules="[checkRequired]"
			:menu-props="{contentClass: 'grv-menu'}"
			@update:error="errored = $event"
			@change="get_contract_assets($event)"
			v-model="form.parameters.legacy_contract_id">
			<template v-slot:label>
				<Label :param="contractid_param"></Label>
			</template>
		</v-autocomplete>
		<Hint :param="contractid_param" :errored="errored"></Hint>

		<AssetIdsField
			:dense="false"
			:readonly="false"
			:loading="loading_contract_assets"
			behive_category="legacy"
			:param="assetids_param"
			:babel_id="babel_id"
			:value.sync="form.parameters.asset_ids">
		</AssetIdsField>

		<div
			class="subheading"
			:class="{ 'error--text': form.parameters.asset_ids.length === 0 }">
			{{ form.parameters.asset_ids.length }}
			<span v-if="form.parameters.asset_ids.length > 1">
				Asset(s) sélectionné(s)
			</span>
			<span v-else>
				Asset sélectionné
			</span>
		</div>
	</v-form>
</template>

<script>
import AssetIdsField from '@/components/fields/assetid.vue'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [ 'details', 'wf_data', 'form' ],
	components: { AssetIdsField, Label, Hint },
	data () {
		return {
			legacy_contracts: [],
			loading_contracts: false,
			loading_contract_assets: false,
			errored: false
		}
	},
	computed: {
		contractid_param () {
			return this.wf_data.parameters.find(param => {
				return param.name === 'legacy_contract_id'
			})
		},
		assetids_param () {
			return this.wf_data.parameters.find(param => {
				return param.name === 'asset_ids'
			})
		},
		babel_id () {
			if (this.form.parameters.legacy_contract_id) {
				for (const contract of this.legacy_contracts) {
					if (contract.id === this.form.parameters.legacy_contract_id) {
						return contract.title_id
					}
				}
			}
			return null
		}
	},
	methods: {
		getLegacyContracts () {
			this.loading_contracts = true
			this.$apiPublic.get_legacy_contracts()
				.then(results => {
					this.legacy_contracts = results
					if (this.details.hasOwnProperty('legacy_contract_id')) {
						for (let i = 0; i < results.length; i++) {
							const contract = results[i]
							if (contract.id === this.details['legacy_contract_id']) {
								this.form.parameters.legacy_contract_id = contract.id
								break
							}
						}
					}
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading_contracts = false
				})
		},
		get_contract_assets () {
			this.loading_contract_assets = true
			this.form.parameters.asset_ids = []
			let contractId = this.form.parameters.legacy_contract_id
			if (!Number.isInteger(contractId)) return
			this.$apiPublic.get_legacy_contract_assets(contractId)
				.then(asset_ids => {
					this.form.parameters.asset_ids = asset_ids
					if (asset_ids.length === 0) {
						this.$Bus.$emit('event_dial', {
							status: 'warning',
							loading: false,
							title: 'Legacy archive contract',
							message: 'Aucun asset trouvé pour ce contrat',
							timeout: 0
						})
					}
				})
				.catch(error => {
					console.error('get_contract_assets', error)
				})
				.finally(() => {
					this.loading_contract_assets = false
				})
		},
		checkRequired (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.getLegacyContracts()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_legacy_archive_contract.vue